<template>
    <div v-bind:class="{'hidden': !isVisible}">
		<div class="lableFormContainer">
			<h2 :id="question.id+'Frage'">{{question.questionText}}</h2>
		</div>
		<div v-if="question.description" v-html="question.description"></div>
		<div v-if="hasError" class="errorBox error"><strong>{{errorText}}</strong></div>
    
        <div v-if="question.propertyInfo.type == 'EMAIL'">
            <input type="text" v-model="valueInt" :id="question.id">
        </div>
        <div v-if="question.propertyInfo.type == 'STRING'">
            <div v-if="showSocialMediaUrlHint">{{getSocialMediaHintText()}}</div>
            <input v-if="readOnly" type="text" v-model="valueInt" :id="question.id" readonly>
            <input v-else type="text" v-model="valueInt" :id="question.id" autocomplete="new-password">
        </div>
        <div v-if="question.propertyInfo.type.kind == 'NUMBER'">
            <input type="text" v-model="valueInt" :id="question.id">
        </div>
 	    <div v-if="question.propertyInfo.type.kind == 'CHOICE'">
            <div v-for="(value, index) in question.propertyInfo.type.allowedValues" class="radioCheckContainer">
                 <input :id="question.id+'_'+index" type="radio" v-model="valueInt" v-bind:value="value" :name="question.id">
                 <label :for="question.id+'_'+index">{{value}}</label>
            </div>
 	    </div>
        <div v-if="question.propertyInfo.type.kind == 'MULTICHOICE'">
            <div v-for="(value, index) in question.propertyInfo.type.allowedValues" class="radioCheckContainer">
                <input :id="question.id+'_'+index" type="checkbox" v-model="valueInt" v-bind:value="value" :name="question.id">
                <label :for="question.id+'_'+index">{{value}}</label>
            </div>
        </div>
        <div v-if="question.propertyInfo.type.kind == 'SCALE'">
            <div v-for="(value, index) in question.propertyInfo.type.allowedValues" class="radioCheckContainer" style="float:left;">
                <input :id="question.id+'_'+index" type="radio" v-model="valueInt" v-bind:value="value" :name="question.id">
                <label :for="question.id+'_'+index">{{value}}</label>
            </div>
            <div style="clear:both;"></div>
        </div>
        <div v-if="question.propertyInfo.type.kind == 'DATETIME'">
            <input type="text" v-model="valueInt">
        </div>
        <div v-if="question.propertyInfo.type == 'BOOLEAN'">
            <div class="radioCheckContainer">
                <input type="checkbox" v-model="valueInt" :id="question.id">
                <label :for="question.id">&nbsp;</label>
            </div>
        </div>
        <div v-if="question.propertyInfo.type.kind == 'DOUBLE_OPTIN'">
            <div class="radioCheckContainer">
                <input type="checkbox" v-model="valueInt" :id="question.id">
                <label :for="question.id">&nbsp;</label>
            </div>
        </div>
        <div v-if="question.propertyInfo.type.kind == 'ADDRESS'">
            <address-question :question="question" ref="addressQuestion"></address-question>
        </div>
        <div v-if="question.propertyInfo.type == 'COUNTRY'">
            <select v-model="valueInt">
	            <option v-for="country in countries" >{{ country }}</option>
            </select>
        </div>
        <div v-if="question.propertyInfo.type.kind == 'MATRIX'" class="oldGridSurvey">
            <div class="clearfix hidden-md-down">
                <div class="gridTitle" style="width:40%">&nbsp;</div>
                <div class="gridValue" :style="'width:calc(60% / '+question.propertyInfo.type.columns.length+')'" v-for="column in question.propertyInfo.type.columns">{{column}}</div>
            </div>
                    
            <div class="clearfix" v-for="(row, rowIndex) in question.propertyInfo.type.rows">
                <div class="gridTitle" style="width:40%">{{row}}</div>
                <div class="gridValue" :style="'width:calc(60% / '+question.propertyInfo.type.columns.length+')'" v-for="(column, columnIndex) in question.propertyInfo.type.columns">
                    <div class="radioCheckContainer">
                        <input v-if="question.propertyInfo.type.type == 'SINGLE_VALUE_ROW'" type="radio" :id="question.id+'_'+rowIndex+'_'+columnIndex" :name="question.id+'_'+rowIndex" v-model="valueInt[row]" v-bind:value="{'left': row, 'right': column}"/>
                        <input v-if="question.propertyInfo.type.type == 'MULTI_VALUE_ROW'" type="checkbox" :id="question.id+'_'+rowIndex+'_'+columnIndex" :name="question.id+'_'+rowIndex" v-model="valueInt[row]" v-bind:value="{'left': row, 'right': column}"/>
                        <label class="clearfix" :for="question.id+'_'+rowIndex+'_'+columnIndex"><span>{{column}}</span></label>
                    </div>
                </div>
            </div>
        </div><!-- end grid -->
        <div class="radioCheckContainer" v-if="question.confirm">
            <input type="checkbox" v-model="confirmed" :id="question.id+'confirm'">
            <label v-if="question.propertyInfo.type.kind == 'ADDRESS'" :for="question.id+'confirm'">Ja, meine Adresse ist korrekt</label>
            <label v-else :for="question.id+'confirm'">&nbsp;</label>
        </div>
        <div v-if="question.afterQuestionContent" v-html="question.afterQuestionContent"></div>
<!--         {{question.questionKey}} -->
<!--         {{question.dependenceExpression}} -->
	</div>
</template>

<script>
    import AddressQuestion from './AddressQuestion.vue'
    
	export default {
		name: 'question-list-entry',
		props: {
            question: Object,
            index: Number,
            socialnetworks: Array,
    		crew: {
	    		type: String,
		    	required: false,
			    default: null
			}
        },
        data: function() {
        	return {
        		selectChoicesLoaded: false,
        		valueInt: this.question.answer.value,
        		isVisible: true,
        		hasError: false,
        		emptyValueText: "Bitte beantworte die Frage",
        		errorText: "",
        		confirmed: false,
        		showSocialMediaUrlHint: false,
        		readOnly: false,
        		initialValueEmpty: false,
                countries:[
                    'Deutschland',
                    'Österreich'
                ]
        	}
        },
        watch: {
        	valueInt: {
        		handler: function(data) {
                    if(data.left) {
                        alert(data.left + ' | ' + data.right);
                    }
                    //console.log('emiting', data, this.index)
                    this.$emit('updateValue', data, this.index);
                },
                deep: true
        	}
        },
        mounted: function() {
			if (this.question.propertyInfo.key.idValue == 'basis.adresse.country') {
				this.valueInt = 'Deutschland'
			}
        	if(this.question.propertyInfo.type.kind == 'CHOICE' || this.question.propertyInfo.type.kind == 'SCALE'
        			|| this.question.propertyInfo.type.kind == 'MULTICHOICE') {
        		
        		this.$parent.addQuestion(jQuery('input[name='+this.question.id+']'), this.question.questionKey, this);
        	}else {
                this.$parent.addQuestion(jQuery('#'+this.question.id), this.question.questionKey, this);
        	}
        	if(this.question.propertyInfo.type == 'BOOLEAN' && this.question.propertyInfo.key.idValue == 'byl.agb.okt17') {
                this.question.description = '<p><a href="/article/nutzungsbedingungen/show.html" target="_blank">Zu den Nutzungsbedingungen</a></p>';
                this.question.afterQuestionContent = '<br /><p>Wir übersenden dir in Zusammenhang mit deiner Registrierung Informationen über eigene ähnliche Waren und Dienstleistungen an die in diesem Zusammenhang von dir angegebene E-Mail Adresse auf Basis des § 7 Absatz 3 UWG. Dieser Verwendung deiner E-Mail-Adresse kannst du jederzeit kostenfrei widersprechen, z.B. per E-Mail an <a href="mailto:team@brandsyoulove.de">team@brandsyoulove.de</a>, ohne dass hierfür andere als die Übermittlungskosten nach den Basistarifen entstehen.</p>'
                + '<p>Weitere Information findest du in unserer <a href="/article/datenschutz/show.html" target="_blank">Datenschutzerklärung</a></p>';
            }
            if(this.question.propertyInfo.type == 'BOOLEAN' && this.question.propertyInfo.key.idValue == 'crew.inStyle.einverstaendnis2023') {
                //keine überschrift
                this.question.questionText = '';
                this.question.description = 'Ich möchte mich als InStyle Crew-Member anmelden und erkläre mich mit den <a href="/article/instylecrewnutzungsbedingungen/show.html" target="_blank">Nutzungsbedingungen</a>'
                +' für die Teilnahme an der InStyle Crew einverstanden.';
                this.question.afterQuestionContent = 'Weitere Informationen zur Verarbeitung deiner personenbezogenen Daten in Zusammenhang mit der Registrierung und'
                +' der Teilnahme an der InStyle Crew findest du in unserer <a href="/article/instylecrewprivacyfaq/show.html" target="_blank"> Datenschutzerklärung</a>.';
            }
            if('inStyle'=== this.crew){
                if(this.question.propertyInfo.key.idValue ==='basis.adresse.street' ){
                    this.question.questionText = 'Straße' ;
                }
                if(this.question.propertyInfo.type==='EMAIL'){
                    this.question.questionText = 'E-Mail Adresse' ;
                }
                if(this.question.propertyInfo.key.idValue ==='basis.instagram.url' || this.question.propertyInfo.key.idValue ==='basis.tiktok.url'){
                	this.isVisible = false;
                }
            }
        	var suffix = '.datenschutzeinwilligung';
        	if(this.question.propertyInfo.type == 'BOOLEAN' && 
                this.question.propertyInfo.key.idValue.indexOf(suffix, this.question.propertyInfo.key.idValue.length - suffix.length) !== -1) {
                this.question.afterQuestionContent = '<p> Weitere Information findest du in unserer <a href="/article/datenschutz/show.html" target="_blank">Datenschutzerklärung</a></p>'
                       + '<p>Mit Absenden meiner Bewerbung erkläre ich mich mit den <a href="/article/nutzungsbedingungen/show.html" target="_blank">Nutzungsbedingungen</a> einverstanden.</p>';
            }
        	this.showSocialMediaUrlHint = this.checkSocialMediaHintVisibility();
        	this.readOnly = this.checkSocialMediaReadOnly();
        	this.initialValueEmpty = this.question.answer.value == null || this.question.answer.value == "";
        },
        methods: {
        	show: function() {
        		if(!this.isVisible) {
	        		var prefill = this.$root.prefill;
	        		if(prefill.hasOwnProperty(this.question.propertyInfo.key.value)) {
	        			if(this.question.propertyInfo.type.kind == 'ADDRESS') {
	                        var address = prefill[this.question.propertyInfo.key.value];
	                        if(address.city) {
	                            this.question.answer.value.city = address.city.value;
	                        }
	                        if(address.street) {
	                        	this.valueInt.street = address.street.value;
	                        }
	                        if(address.number) {
	                            this.valueInt.number = address.number.value;
	                        }
	                        if(address.firstName) {
	                            this.valueInt.firstname = address.firstName.value;
	                        }
	                        if(address.lastName) {
	                            this.valueInt.lastname = address.lastName.value;
	                        }
	                        if(address.zip) {
	                            this.valueInt.zip = address.zip.value;
	                        }
	                        if(address.country) {
	                            this.valueInt.country = address.country.value;
	                        }
	                    }else if(this.question.propertyInfo.type.kind == 'MULTICHOICE' || this.question.propertyInfo.type.kind == 'MATRIX' || this.question.propertyInfo.type == 'BOOLEAN') {
	                        //do nothing for now
// 	                        console.log(prefill[this.question.propertyInfo.key.value]);
// 	                        console.log(prefill[this.question.propertyInfo.key.value].containedPropertyEntries);
	                        prefill[this.question.propertyInfo.key.value].containedPropertyEntries.forEach(function(item) {
// 	                        	console.log(item.fragment.value);
// 	                        	console.log(item.value);
	                        });
	                    }else {
	                    	this.valueInt = prefill[this.question.propertyInfo.key.value].value;
	                    }
	        		}
        		}
       		    this.isVisible = true;
        	},
        	hide: function() {
        		if(this.isVisible) {
	                if(this.question.propertyInfo.type.kind == 'ADDRESS') {
	                    this.valueInt = {};
	                }else if(this.question.propertyInfo.type.kind == 'MULTICHOICE') {
	                	this.valueInt = [];
	                }else if(this.question.propertyInfo.type.kind == 'MATRIX') {
	                	this.valueInt = {};
	                }else {
	                	this.valueInt = "";
	                }
        		}
       		    this.isVisible = false;
            },
            onValidate: function() {
            	this.hasError = false;
                if('crew.inStyle.einverstaendnis2023'===this.question.propertyInfo.key.value
                || 'byl.agb.okt17'===this.question.propertyInfo.key.value){
                    //console.log('es geht los');
                }
            	if (this.question.required === true && this.isVisible === true) {
            		if(this.question.propertyInfo.key.value === 'byl.agb.okt17') {
                        if(!this.question.answer.value) {
                            this.errorText = "Bitte bestätige die Nutzungsbedingungen und den Datenschutz";
                            this.hasError = true;
                        }
                    }else if(this.question.propertyInfo.key.value === 'crew.inStyle.einverstaendnis2023'){
                        if(!this.question.answer.value) {
                            this.errorText = "Bitte bestätige Sie Ihr Einverständnis";
                            this.hasError = true;
                        }
                    }else if(this.question.propertyInfo.key.value.length >= 'datenschutzeinwilligung'.length &&
                            this.question.propertyInfo.key.value.lastIndexOf('datenschutzeinwilligung') === this.question.propertyInfo.key.value.length - 'datenschutzeinwilligung'.length) {
                        if(!this.question.answer.value) {
                            this.errorText = "Bitte bestätige die Nutzungsbedingungen und den Datenschutz";
                            this.hasError = true;
                        }
                    }else if('basis.adresse.country'===this.question.propertyInfo.key.value){
                        //console.log(this.question.answer);
                        //console.log(this.question.answer.valueInt);
                        if(!this.question.answer.value) {
                            this.errorText = "Bitte wählen Sie ein Land aus";
                            this.hasError = true;
                        }
                    }else if(this.question.propertyInfo.type.kind == 'ADDRESS') {
                        this.hasError = this.$refs.addressQuestion.onValidate();
            			this.errorText = "Keine vollständige / gültige Adresse"; 
                    }else if (this.question.answer.type == 'MATRIX') {
                        let rows = this.question.propertyInfo.type.rows;
                        let given = this.question.answer.value;
                        for (let i = 0; i < rows.length; i++) {
                            if (!given.hasOwnProperty(rows[i])) {
                                console.debug('Missing ' + rows[i]);
                                this.errorText = this.emptyValueText;
                                this.hasError = true;
                                break;
                            }
                        }
                    }
                    else if (this.question.answer.value === undefined || this.question.answer.value.length == 0) {
                    	this.errorText = this.emptyValueText;
                        this.hasError = true;
                        console.debug(JSON.stringify(this.question));
                    }
                    else if (this.question.propertyInfo.type == 'STRING') {
                        if (typeof this.question.answer.value.trim === "function" && this.question.answer.value.trim().length == 0) { 
                            this.errorText = this.emptyValueText;
                            this.hasError = true;
                            console.debug(JSON.stringify(this.question));
                        }
                    }
                    else if (this.question.propertyInfo.type.kind == 'NUMBER') {
                        var numberPattern = new RegExp('^\\d+$', 'i');
                        if(!numberPattern.test(this.question.answer.value)) {
                        	this.errorText = "Bitte gib eine Zahl an";
                        	this.hasError = true;
                        } else {
                            if (this.question.answer.value < this.question.propertyInfo.type.minimum ||
                            this.question.answer.value > this.question.propertyInfo.type.maximum) {
                                this.errorText = "Die Zahl sollte zwischen " + 
                                    this.question.propertyInfo.type.minimum + 
                                    " und " + 
                                    this.question.propertyInfo.type.maximum + 
                                    " liegen";
                                this.hasError = true;
                            }
                        }
                    }
                    else if (this.question.propertyInfo.type.kind == 'DATETIME' && this.question.propertyInfo.key.value == "basis.geburtsdatum") {
                    	var matches = /^(\d{1,2})[\.](\d{1,2})[\.](\d{4})$/.exec(this.question.answer.value);
                        if (matches == null){
                        	this.errorText = "Falsches Datumsformat";
                        	this.hasError = true;
                        }else {
	                        var d = matches[1];
	                        var m = matches[2] - 1;
	                        var y = matches[3];
	                        var birthday = new Date(y, m, d);
                    		
                            var date = new Date(Date.now());
                            date.setFullYear(date.getFullYear() - 16);
                            if(birthday > date) {
                            	this.errorText = "Du musst mindesten 16 Jahre alt sein";
                            	this.hasError = true;
                            }
                        }
                    }
                    else if (this.question.propertyInfo.type.kind == 'MULTICHOICE') {
                    	var min = this.question.propertyInfo.type.minSelect;
                    	var max = this.question.propertyInfo.type.maxSelect;
                    	var answerCount = this.question.answer.value.length;
                    	if(min > answerCount) {
                    		this.errorText = "Zu wenige Optionen ausgewählt. Bitte wähle mindestens " + min;
                            this.hasError = true;
                    	}
                    	if(max < answerCount) {
                            this.errorText = "Zu viele Optionen ausgewählt. Bitte wähle höchstens " + max;
                            this.hasError = true;
                        }
                    }
            		if(!this.hasError && this.question.confirm) {
            			if(!this.confirmed) {
	            			this.errorText = "Bitte bestätige die Frage";
	            			this.hasError = true;
            			}
            		}
                }
				//console.log('validated:', this.question.propertyInfo.key.value, 'has Error: ', this.hasError);
            	return this.hasError;
            },
            checkSocialMediaHintVisibility: function() {
                //if(this.question.propertyInfo.key.value === 'basis.twitter.url' || this.question.propertyInfo.key.value === 'basis.instagram.url') {
                //	return true;
                //}
                return false;
            },
            checkSocialMediaReadOnly: function() {
            	var result = false;
            	if(this.question.propertyInfo.key.value === 'basis.twitter.url' || this.question.propertyInfo.key.value === 'basis.instagram.url') {
	                if(this.socialnetworks) {
	                	if(this.question.answer.value == null || this.question.answer.value == "") {
	                		result = false;
	                		return;
	                	}if(this.question.propertyInfo.key.value === 'basis.twitter.url') {
	                        this.socialnetworks.forEach(function(entry) {
	                            if(entry.type == "TWITTER") {
	                                result = true;
	                                return;
	                            }
	                        });
	                    }else if(this.question.propertyInfo.key.value === 'basis.instagram.url') {
	                        this.socialnetworks.forEach(function(entry) {
	                            if(entry.type == "INSTAGRAM") {
	                                result = true;
	                                return;
	                            }
	                        });
	                    }
	                }
            	}
                return result;
            },
            getSocialMediaHintText: function() {
            	var result = "";
                if(this.question.propertyInfo.key.value === 'basis.twitter.url') {
               		result = "Tipp: Damit du die genaue Zahl nicht mehr prüfen und laufend aktualisieren musst, kannst du deinen Twitter-Account ganz einfach in deinem brands you love-Profil verknüpfen. So ist deine Angabe immer korrekt und wir können dich viel einfacher für aktuelle Aktionen berücksichtigen.";
                	if(this.socialnetworks) {
                		if(!this.initialValueEmpty) {
		                    this.socialnetworks.forEach(function(entry) {
		                        if(entry.type == "TWITTER") {
		                        	result = "Schon erledigt, deinen Twitter-Account hast du im brands you love-Profil bereits erfolgreich verknüpft.";
		                            return;
		                        }
		                    });
                        }
                	}
                } else if(this.question.propertyInfo.key.value === 'basis.instagram.url') {
               		result = "Tipp: Damit du die genaue Zahl nicht mehr prüfen und laufend aktualisieren musst, kannst du deinen Instagram-Account ganz einfach in deinem brands you love-Profil verknüpfen. So ist deine Angabe immer korrekt und wir können dich viel einfacher für aktuelle Aktionen berücksichtigen.";
                	if(this.socialnetworks) {
                		if(!this.initialValueEmpty) {
		                    this.socialnetworks.forEach(function(entry) {
		                        if(entry.type == "INSTAGRAM") {
		                        	result = "Schon erledigt, deinen Instagram-Account hast du im brands you love-Profil bereits erfolgreich verknüpft.";
		                            return;
		                        }
		                    });
                        }
                	}
                }
	            return result;
            }
        },
        components: { AddressQuestion }
	}
</script>

<style>
    .hidden { display: none; }
</style>


// WEBPACK FOOTER //
// QuestionListEntry.vue?494486fa